import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import MaterialTable from 'material-table';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Switch, FormControlLabel } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IconButton from '@material-ui/core/IconButton';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import GetAppIcon from '@material-ui/icons/GetApp';
import AddAPhotoRoundedIcon from '@material-ui/icons/AddAPhotoRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';

import * as ProductsManagerClient from '../clients/ProductsManager';
import categories from '../images/categories';

const styles = (theme) => ({
    root: {
        padding: 40,
        position: 'relative',
    },
    paper: {
        paddingTop: '1rem',
        paddingBottom: '1rem',
        paddingLeft: '3rem',
        paddingRight: '3rem',
        textAlign: 'left',
        marginBottom: '2rem',
    },
    input: {
        width: 300,
        marginRight: '3rem',
    },
});

function formatDate(dateString) {
    if (dateString !== undefined) {
        let date = new Date(dateString);
        const offset = date.getTimezoneOffset();
        date = new Date(date.getTime() + offset * 60 * 1000);
        return date.toISOString().slice(0, 16);
    }
    return undefined;
}

class ProductEditorInternal extends Component {
    constructor(props) {
        super(props);

        if (this.props.isUpdate === true) {
            this.state = {
                name: props.data.name,
                format: props.data.format,
                cut: props.data.cut,
                newFormat: props.data.format,
                newCut: props.data.cut,
                gr: props.data.gr,
                unit: props.data.unit,
                price: props.data.price,
                priceKg: props.data.priceKg,
                dateFrom: formatDate(props.data.dateFrom),
                dateTo: formatDate(props.data.dateTo),
                min48hPreparation: props.data.min48hPreparation,
            };
        } else {
            this.state = {};
        }
    }

    handleInputChange = (evt) => {
        this.setState({ [evt.target.name]: evt.target.value, changesPending: true });
    };

    handleMin48hChange = (evt) => {
        this.setState({ min48hPreparation: evt.target.checked, changesPending: true });
    };

    handleRemoveDates = () => {
        this.setState({ dateFrom: undefined, dateTo: undefined, changesPending: true });
    };

    handleUploadImage = (imageType) => (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = () => {
            if (reader.result.indexOf('image/jpeg') !== -1) {
                ProductsManagerClient.updateProduct({ ...this.props.data, ...this.state }, reader.result.split(',')[1])
                    .then(() => {
                        this.setState({ changesPending: false });
                        this.forceUpdate();
                        this.props.onShowMessage('Producto actualizado', 'success');
                        // this.props.onProductUpdated(this.props.data);
                    })
                    .catch((err) => {
                        this.props.onShowMessage(err.toString(), 'error');
                    });
            } else {
                this.onShowMessage('Formato de imagen incorrecto, debe ser un JPEG', 'error');
            }
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };

    handleUpdateProduct = () => {
        ProductsManagerClient.updateProduct({ ...this.props.data, ...this.state })
            .then(() => {
                this.setState({ changesPending: false });
                this.forceUpdate();
                this.props.onShowMessage('Producto actualizado', 'success');
                this.props.onProductUpdated(this.props.data);
            })
            .catch((err) => this.props.onShowMessage(err.toString(), 'error'));
    };

    handleAddProduct = () => {
        ProductsManagerClient.addProduct({ ...this.props.data, ...this.state })
            .then(() => {
                this.setState({ changesPending: false });
                this.forceUpdate();
                this.props.onShowMessage('Producto agregado', 'success');
                this.props.onProductUpdated(this.props.data);
            })
            .catch((err) => this.props.onShowMessage(err.toString(), 'error'));
    };

    render() {
        return (
            <div style={{ padding: '3rem', color: '#000', fontSize: '1rem' }}>
                <Paper className={this.props.classes.paper}>
                    <h3>Características</h3>
                    {this.props.isUpdate === true && (
                        <>
                            <TextField className={this.props.classes.input} label="Nombre" value={this.state.name} name="name" onChange={this.handleInputChange} />
                            <TextField className={this.props.classes.input} label="Formato" value={this.state.newFormat} name="newFormat" onChange={this.handleInputChange} />
                            <TextField className={this.props.classes.input} label="Corte" value={this.state.newCut} name="newCut" onChange={this.handleInputChange} />{' '}
                        </>
                    )}
                    {this.props.isUpdate === false && (
                        <>
                            <TextField select className={this.props.classes.input} label="Categoría" name="category" value={this.state.category} onChange={this.handleInputChange}>
                                {Object.keys(categories).map((k) => (
                                    <MenuItem key={k} value={k}>
                                        {k}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <TextField className={this.props.classes.input} label="Id" value={this.state.id} name="id" onChange={this.handleInputChange} />
                            <TextField className={this.props.classes.input} label="Nombre" value={this.state.name} name="name" onChange={this.handleInputChange} />
                            <TextField className={this.props.classes.input} label="Formato" value={this.state.format} name="format" onChange={this.handleInputChange} />
                            <TextField className={this.props.classes.input} label="Corte" value={this.state.cut} name="cut" onChange={this.handleInputChange} />
                        </>
                    )}
                    <TextField className={this.props.classes.input} label="Gramaje" value={this.state.gr} name="gr" onChange={this.handleInputChange} />
                    <TextField className={this.props.classes.input} label="Unidad" value={this.state.unit} name="unit" onChange={this.handleInputChange} />
                    <FormControlLabel control={<Switch color="primary" checked={this.state.min48hPreparation} onChange={this.handleMin48hChange} />} label="Requiere 48h de preparación" />
                </Paper>
                <Paper className={this.props.classes.paper}>
                    <h3>Precios</h3>
                    <TextField
                        className={this.props.classes.input}
                        label="Precio"
                        type="number"
                        value={this.state.price}
                        name="price"
                        onChange={this.handleInputChange}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">€</InputAdornment>,
                        }}
                    />
                    <TextField
                        className={this.props.classes.input}
                        label="Precio/Kg"
                        type="number"
                        value={this.state.priceKg}
                        name="priceKg"
                        onChange={this.handleInputChange}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">€/Kg</InputAdornment>,
                        }}
                    />
                </Paper>

                <Paper className={this.props.classes.paper}>
                    <h3>Período de oferta</h3>
                    <TextField
                        className={this.props.classes.input}
                        label="Fecha inicio oferta"
                        type="datetime-local"
                        value={this.state.dateFrom}
                        name="dateFrom"
                        onChange={this.handleInputChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className={this.props.classes.input}
                        label="Fecha fin oferta"
                        type="datetime-local"
                        value={this.state.dateTo}
                        name="dateTo"
                        onChange={this.handleInputChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    {this.props.isUpdate && (
                        <>
                            {this.props.data.imageUrl && <img className="sale-image-thumbnail" alt="Imagen oferta" src={this.props.data.imageUrl} />}
                            <input accept="image/jpeg" id="upload-file-sale-image" type="file" style={{ display: 'none' }} onChange={this.handleUploadImage('sale')} />
                            <label htmlFor="upload-file-sale-image">
                                <IconButton color="primary" component="span">
                                    <AddAPhotoRoundedIcon />
                                </IconButton>
                            </label>
                        </>
                    )}
                    <br />
                    <br />
                    {(this.state.dateFrom !== undefined || this.state.dateTo !== undefined) && (
                        <>
                            <Button startIcon={<HighlightOffRoundedIcon />} variant="contained" color="secondary" onClick={this.handleRemoveDates}>
                                Quitar periodo de oferta
                            </Button>
                        </>
                    )}
                </Paper>
                {this.state.changesPending && (
                    <Button startIcon={<SaveRoundedIcon />} variant="contained" color="primary" onClick={this.props.isUpdate ? this.handleUpdateProduct : this.handleAddProduct}>
                        {this.props.isUpdate ? 'Guardar cambios' : 'Añadir artículo'}
                    </Button>
                )}
                {/* </Grid> */}
            </div>
        );
    }
}
const ProductEditor = withStyles(styles)(ProductEditorInternal);

class ProductsManager extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            platformId: undefined, // Undefined on create
            alertOpen: false,
            alertMessage: '',
            alertSeverity: 'success',
            activeStep: 0,
            receivingAccount: '',
            termsChecked: false,
            loading: true,
            addProductOpen: false,
            columns: [
                {
                    field: 'category',
                    title: 'Categoría',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    field: 'id',
                    title: 'Id',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    field: 'name',
                    title: 'Nombre',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    field: 'format',
                    title: 'Formato',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    field: 'cut',
                    title: 'Corte',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    field: 'gr',
                    title: 'Gramaje',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span>{rowData['gr'] ? rowData['gr'].toLocaleString() : ''}</span>,
                },
                {
                    field: 'unit',
                    title: 'Unidad',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    field: 'priceKg',
                    title: 'Precio Kg',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span>{rowData['priceKg'] ? rowData['priceKg'].toLocaleString() : ''}</span>,
                },
                {
                    field: 'price',
                    title: 'Precio',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span>{rowData['price'] ? rowData['price'].toLocaleString() : ''}</span>,
                },
                {
                    field: 'dateFrom',
                    title: 'Oferta desde',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => <span>{rowData['dateFrom'] ? new Date(rowData['dateFrom']).toLocaleDateString() : ''}</span>,
                },
                {
                    field: 'dateTo',
                    title: 'Oferta hasta',
                    editable: 'never',
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    render: (rowData) => (
                        <span style={{ color: rowData['dateTo'] ? (new Date(rowData['dateTo']) < new Date() ? 'red' : 'black') : 'black' }}>
                            {rowData['dateTo'] ? new Date(rowData['dateTo']).toLocaleDateString() : ''}
                        </span>
                    ),
                },
            ],
        };
    }

    showMessage = (alertMessage, alertSeverity) => {
        this.setState({ alertMessage, alertSeverity, alertOpen: true });
    };

    handleClose = () => {
        this.setState({ alertOpen: false });
    };

    handleCloseAddProduct = () => {
        this.setState({ addProductOpen: false });
    };

    handleProductUpdated = (product) => {
        this.refreshProductsList();
    };

    refreshProductsList = () => {
        ProductsManagerClient.invalidateCache();
        this.tableRef.current && this.tableRef.current.onQueryChange();
        ProductsManagerClient.getAll().then((data) => this.setState({ data }));
    };

    handleDataDownload = async () => {
        let converter = require('json-2-csv');
        var fileDownload = require('js-file-download');
        const data = await ProductsManagerClient.getAllNoPage(0, 999999);
        //,,,,,,,,,,imageS3Key,imageUrl,
        const csv = await converter.json2csvAsync(data, {
            keys: ['category', 'id', 'cut', 'format', 'name', 'priceKg', 'price', 'unit', 'gr', 'dateTo', 'dateFrom'],
            excelBOM: true,
            emptyFieldValue: '',
        });
        fileDownload(csv, 'productos.csv');
    };

    render() {
        return (
            <div className={this.props.classes.root}>
                <Snackbar autoHideDuration={6000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.alertOpen} onClose={this.handleClose}>
                    <MuiAlert elevation={6} variant="filled" severity={this.state.alertSeverity} onClose={this.handleClose}>
                        {this.state.alertMessage}
                    </MuiAlert>
                </Snackbar>
                <div style={{ textAlign: 'right' }}>
                    <Button startIcon={<GetAppIcon />} variant="contained" color="secondary" onClick={this.handleDataDownload}>
                        Descargar productos (csv)
                    </Button>{' '}
                    <Button startIcon={<AddRoundedIcon />} variant="contained" color="primary" onClick={() => this.setState({ addProductOpen: true })}>
                        Añadir artículo
                    </Button>
                </div>
                <br />
                <MaterialTable
                    title="Productos"
                    tableRef={this.tableRef}
                    style={{ minHeight: 'calc(100vh - 160px)' }}
                    columns={this.state.columns}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            ProductsManagerClient.getAll(query.page + 1, query.pageSize, query.search).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page - 1,
                                    totalCount: result.total,
                                });
                            });
                        })
                    }
                    options={{
                        search: true,
                        pageSize: 50,
                        actionsColumnIndex: -1,
                    }}
                    localization={{
                        pagination: {
                            labelDisplayedRows: '{from}-{to} de {count}',
                        },
                        toolbar: {
                            nRowsSelected: '{0} filas(s) seleccionadas',
                            searchTooltip: 'Buscar',
                            searchPlaceholder: 'Buscar',
                        },
                        header: {
                            actions: '',
                        },
                        body: {
                            emptyDataSourceMessage: 'No hay datos a mostrar',
                            filterRow: {
                                filterTooltip: 'Filtro',
                            },
                        },
                    }}
                    detailPanel={[
                        {
                            tooltip: 'Mostrar producto',
                            render: (rowData) => {
                                return (
                                    <div
                                        style={{
                                            fontSize: 100,
                                            textAlign: 'center',
                                            color: 'white',
                                        }}
                                    >
                                        <ProductEditor onShowMessage={this.showMessage} onProductUpdated={this.handleProductUpdated} isUpdate={true} data={rowData} />
                                    </div>
                                );
                            },
                        },
                    ]}
                    actions={[
                        // (rowData) => ({
                        //     icon: () => (rowData.Enabled === true ? <LockOpenIcon /> : <LockIcon />),
                        //     tooltip: rowData.Enabled === true ? 'Disable user' : 'Enable user',
                        //     onClick: () => (rowData.Enabled === true ? this.disableUser(rowData['Username']) : this.enableUser(rowData['Username'])),
                        // }),
                        // (rowData) => ({
                        //     icon: () => <PersonAddIcon />,
                        //     tooltip: 'Confirm user',
                        //     onClick: () => this.confirmUser(rowData['Username']),
                        //     disabled: rowData['UserStatus'] !== 'UNCONFIRMED',
                        // }),
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => this.refreshProductsList(),
                        },
                    ]}
                />

                <Dialog open={this.state.addProductOpen} maxWidth={'xl'} onClose={this.handleCloseAddProduct} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Añadir artículo</DialogTitle>
                    <DialogContent>
                        <ProductEditor onShowMessage={this.showMessage} onProductUpdated={this.handleProductUpdated} isUpdate={false} />
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(ProductsManager);
